import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { DecisionRulesSection } from "../decision-table/DecisionRulesSection";
import { useStepSuggestionInfoMap } from "./useStepSuggestionInfoMap";
/**
 * One step's decision table on its own — the sibling of
 * `ProcessFlowStepDetailContent` for a surface that wants ONLY the rules.
 *
 * It exists so such a surface consumes the same LEVEL of this package as the
 * full detail does. Reaching past it to the `DecisionRulesSection` primitive
 * works, but forces every host to reproduce the prologue this component owns —
 * the suggestion-map union and the read-only prop set — and a host that gets
 * either subtly wrong degrades silently to id-only placeholders or, worse,
 * grows edit affordances on a read-only surface.
 *
 * Read-only by construction: the three edit callbacks are not forwarded and
 * there is no prop to supply them, so the table has no × per successor and no
 * click-to-edit cell. An editing host uses `EditableStepDetailContent` instead.
 *
 * Renders nothing when the step has no table — `DecisionRulesSection`'s own
 * empty-rules branch. A host that needs to SAY so (rather than show a blank)
 * asks `hasDecisionRules(step)` from `@bliks-io/contracts` first.
 */ export function ProcessFlowStepDecisionRules({ step, assigneeLookup = {}, entitySuggestions }) {
    const { t } = useTranslation();
    const suggestionInfoById = useStepSuggestionInfoMap(step, entitySuggestions);
    return /*#__PURE__*/ _jsx(DecisionRulesSection, {
        rules: step.rules ?? [],
        t: t,
        assigneeLookup: assigneeLookup,
        suggestionInfoById: suggestionInfoById
    });
}

//# sourceMappingURL=ProcessFlowStepDecisionRules.js.map